<template>
  <div>
    <h5>电子招标文件</h5>
    <!---基本信息--->
    <div class="section">
      <h6>基本信息</h6>
      <div class="flex col-center row-between base-info">
        <div class="flex col-center flex-wrap">
          <div class="flex col-center p-v-8 flex-wrap">
            <div class="item-body">
              <span class="item-body__label">评审模式：</span>
              <span class="item-body__content">{{ reviewModelLabel }}</span>
            </div>
            <div class="item-body">
              <el-divider direction="vertical" />
              <span class="item-body__label">评审办法：</span>
              <span class="item-body__content">{{ reviewMethodLabel }}</span>
            </div>
            <div class="item-body">
              <el-divider direction="vertical" />
              <span class="item-body__label">开标地点：</span>
              <span class="item-body__content">{{ addressStr }}</span>
            </div>

            <div class="item-body">
              <el-divider direction="vertical" />
              <span class="item-body__label">开标详细地址：</span>
              <span class="item-body__content">
                {{ fileInfo.openBidAddress }}
              </span>
            </div>

            <div class="item-body">
              <el-divider direction="vertical" />
              <span class="item-body__label">
                中标候选人推荐
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="默认推荐对应候选人数量在评审报告中体现"
                  placement="top"
                >
                  <i class="el-icon-info"></i>
                </el-tooltip>
                ：
              </span>
              <span class="item-body__content">
                {{ fileInfo.recommendCandidateNum }}
              </span>
            </div>
            <template v-if="showItemOffer">
              <div class="item-body">
                <el-divider direction="vertical" />
                <span class="item-body__label">是否开启分项报价：</span>
                <span class="item-body__content">
                  {{ fileInfo.isEnableItemOffer ? '是' : '否' }}
                </span>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>

    <!----投标文件目录----->
    <div class="section">
      <h6>{{ isDouble ? '商务文件目录' : '投标文件目录' }}</h6>
      <section>
        <template v-for="item in catalogList">
          <div
            v-if="showCatalog(item)"
            :key="item.orderNum"
            class="list flex col-center row-between"
          >
            <div class="flex col-center p-v-8">
              <div class="item-body">
                <span class="item-body__label">目录序号：</span>
                <span class="item-body__content">
                  {{ getContent({ value: item.orderNum }) }}
                </span>
              </div>
              <el-divider direction="vertical" />
              <div class="item-body">
                <span class="item-body__label">目录名称：</span>
                <el-popover
                  v-if="getContent({ value: item.catalogName }).length > 26"
                  placement="top"
                  trigger="hover"
                  width="300"
                  :content="getContent({ value: item.catalogName })"
                >
                  <span slot="reference" class="item-body__content">
                    {{
                      getContentAfterSubstr(
                        getContent({ value: item.catalogName })
                      )
                    }}
                  </span>
                </el-popover>
                <span v-else class="item-body__content">
                  {{ getContent({ value: item.catalogName }) }}
                </span>
              </div>
              <el-divider direction="vertical" />
              <div class="item-body">
                <span class="item-body__label">是否必须上传：</span>
                <span class="item-body__content">
                  {{
                    getContent({
                      value: item.uploadRequire,
                      dict: whetherBooleanDict
                    })
                  }}
                </span>
              </div>
              <el-divider direction="vertical" />
              <div class="item-body">
                <span class="item-body__label">是否需盖章：</span>
                <span class="item-body__content">
                  {{
                    getContent({
                      value: item.signRequire,
                      dict: whetherBooleanDict
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </section>
    </div>
    <!--报价文件目录-->
    <div v-if="quotationCatalogList.length" class="section">
      <h6>报价文件目录</h6>
      <section>
        <template v-for="item in quotationCatalogList">
          <div
            v-if="showCatalog(item)"
            :key="item.orderNum"
            class="list flex col-center row-between"
          >
            <div class="flex col-center p-v-8">
              <div class="item-body">
                <span class="item-body__label">目录序号：</span>
                <span class="item-body__content">
                  {{ getContent({ value: item.orderNum }) }}
                </span>
              </div>
              <el-divider direction="vertical" />
              <div class="item-body">
                <span class="item-body__label">目录名称：</span>
                <el-popover
                  v-if="getContent({ value: item.catalogName }).length > 26"
                  placement="top"
                  trigger="hover"
                  width="300"
                  :content="getContent({ value: item.catalogName })"
                >
                  <span slot="reference" class="item-body__content">
                    {{
                      getContentAfterSubstr(
                        getContent({ value: item.catalogName })
                      )
                    }}
                  </span>
                </el-popover>
                <span v-else class="item-body__content">
                  {{ getContent({ value: item.catalogName }) }}
                </span>
              </div>
              <el-divider direction="vertical" />
              <div class="item-body">
                <span class="item-body__label">是否必须上传：</span>
                <span class="item-body__content">
                  {{
                    getContent({
                      value: item.uploadRequire,
                      dict: whetherBooleanDict
                    })
                  }}
                </span>
              </div>
              <el-divider direction="vertical" />
              <div class="item-body">
                <span class="item-body__label">是否需盖章：</span>
                <span class="item-body__content">
                  {{
                    getContent({
                      value: item.signRequire,
                      dict: whetherBooleanDict
                    })
                  }}
                </span>
              </div>
            </div>
          </div>
        </template>
      </section>
    </div>

    <!-----评审办法------>
    <div class="section review-methods">
      <h6>评审办法</h6>
      <section>
        <div class="item-body m-b-16">
          <span class="item-body__label">评分设置：</span>
          <span class="item-body__content">
            精确至小数点后{{ fileInfo.decimalPoint || 4 }}位
          </span>
        </div>
        <div v-if="showScoreOnce" class="item-body m-b-16">
          <span class="item-body__label">
            商务、技术、价格评审是否可同时进行：
          </span>
          <span class="item-body__content">
            {{
              getContent({
                value: fileInfo.isScoreOnce,
                dict: isScoreOnceDict
              })
            }}
          </span>
        </div>
        <div class="flex flex-wrap">
          <div
            v-for="review in reviewList"
            :key="review.wayType"
            class="review-card"
          >
            <div class="review-card-head">
              {{
                getContent({
                  value: review.wayType,
                  dict: reviewWayTypeDict(fileInfo.reviewModel)
                })
              }}
            </div>

            <!-- 价格分评审，在最高价/最低价下的显示 -->
            <div
              v-if="isRankByPrice && isQuotationReview(review)"
              class="p-v-14 p-h-16"
            >
              您已设置为{{
                reviewMethodLabel
              }}，价格分评审无需设置，系统会根据供应商报价自动排序
            </div>
            <div
              v-for="(item, itemIndex) in review.itemList"
              :key="item.orderNum"
              class="list flex col-center row-between"
            >
              <div class="flex col-center flex-wrap p-v-14 p-h-16">
                <!-- 手动算分 -->
                <div
                  v-if="
                    isScore(review) &&
                      itemIndex === 0 &&
                      review.scoringType !==
                      bidReviewScoringTypeDict.AUTOMATIC.value
                  "
                  class="score-setting"
                >
                  <div class="item-body">
                    <span class="item-body__label">评审总分值：</span>
                    <span class="item-body__content">
                      {{ getContent({ value: review.scoreSum }) }}
                    </span>
                  </div>
                  <el-divider direction="vertical" />
                  <div class="item-body">
                    <span class="item-body__label">评分方案：</span>
                    <span class="item-body__content">
                      {{
                        getContent({
                          value: review.scoreMethod,
                          dict: bidReviewScoringSchemeDict
                        })
                      }}
                    </span>
                  </div>
                </div>
                <!-- 自动算分 -->
                <automatic-scoring-detail
                  v-if="
                    review.scoringType ===
                      bidReviewScoringTypeDict.AUTOMATIC.value
                  "
                  class="score-setting"
                  :review-way="review"
                />
                <div class="flex flex-wrap" style="width: 100%;">
                  <div class="item-body m-b-12">
                    <span class="item-body__label">
                      {{ getReviewPointLabel(review) }}点序号：
                    </span>
                    <span class="item-body__content">
                      {{ getContent({ value: item.orderNum }) }}
                    </span>
                  </div>
                  <el-divider class="m-b-12" direction="vertical" />
                  <div class="item-body m-b-12">
                    <span class="item-body__label">
                      {{ getReviewPointLabel(review) }}点名称：
                    </span>
                    <el-popover
                      v-if="getContent({ value: item.itemName }).length > 26"
                      placement="top"
                      trigger="hover"
                      width="300"
                      :content="getContent({ value: item.itemName })"
                    >
                      <span slot="reference" class="item-body__content">
                        {{
                          getContentAfterSubstr(
                            getContent({ value: item.itemName })
                          )
                        }}
                      </span>
                    </el-popover>
                    <span v-else class="item-body__content">
                      {{ getContent({ value: item.itemName }) }}
                    </span>
                  </div>
                  <el-divider class="m-b-12" direction="vertical" />
                  <div class="item-body m-b-12">
                    <span class="item-body__label">
                      {{ getReviewPointLabel(review) }}点类型：
                    </span>
                    <span class="item-body__content">
                      {{
                        getContent({
                          value: item.reviewType,
                          dict: bidReviewPointTypeDict
                        })
                      }}
                    </span>
                  </div>
                  <template v-if="isScore(review)">
                    <el-divider class="m-b-12" direction="vertical" />
                    <div class="item-body m-b-12">
                      <span class="item-body__label">单项最低分：</span>
                      <span class="item-body__content">
                        {{ getContent({ value: item.minScore, fixed2: true }) }}
                      </span>
                    </div>
                    <el-divider class="m-b-12" direction="vertical" />
                    <div class="item-body m-b-12">
                      <span class="item-body__label">单项最高分：</span>
                      <span class="item-body__content">
                        {{ getContent({ value: item.maxScore, fixed2: true }) }}
                      </span>
                    </div>
                  </template>
                </div>
                <div class="item-body__one_line">
                  <span class="item-body__label">
                    {{ getReviewPointLabel(review) }}标准：
                  </span>
                  <span class="item-body__content">
                    {{ getContent({ value: item.itemStandard }) }}
                  </span>
                </div>
                <div class="item-body__one_line m-t-10" style="width: 100%">
                  <span class="item-body__label">关联投标文件目录：</span>
                  <span class="item-body__content">
                    {{
                      getCatalogNameByOrderNum(
                        item.relationCatalog && item.relationCatalog.orderNum
                      )
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!----开标一览表----->
    <div class="section">
      <h6>开标一览表</h6>
      <section>
        <div
          v-for="item in markList"
          :key="item.orderNum"
          class="list flex col-center row-between"
        >
          <div class="flex col-center p-v-8">
            <div class="item-body">
              <span class="item-body__label">一览表序号：</span>
              <span class="item-body__content">
                {{ getContent({ value: item.orderNum }) }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">开标项填写：</span>
              <el-popover
                v-if="getContent({ value: item.markName }).length > 26"
                placement="top"
                trigger="hover"
                width="300"
                :content="getContent({ value: item.markName })"
              >
                <span slot="reference" class="item-body__content">
                  {{
                    getContentAfterSubstr(getContent({ value: item.markName }))
                  }}
                </span>
              </el-popover>
              <span v-else class="item-body__content">
                {{ getContent({ value: item.markName }) }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">填写类型：</span>
              <span class="item-body__content">
                {{
                  getContent({
                    value: item.inputType,
                    dict: bidMarkInputTypeDict
                  })
                }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">单位类型：</span>
              <span
                v-if="item.markType === bidMarkTypeDict.BID_TOTAL.value"
                class="item-body__content"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="投标报价的单位类型由项目所选的报价方式决定"
                  placement="top"
                >
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </span>
              <span v-else class="item-body__content">
                {{
                  getContent({
                    value: item.markUnit,
                    dict: bidMarkUnitTypeDict
                  })
                }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">是否必填：</span>
              <span class="item-body__content">
                {{
                  getContent({
                    value: item.markRequire,
                    dict: whetherBooleanDict
                  })
                }}
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- 报价开标一览表-->
    <div v-if="quotationMarkList.length" class="section">
      <h6>报价开标一览表</h6>
      <section>
        <div
          v-for="item in quotationMarkList"
          :key="item.orderNum"
          class="list flex col-center row-between"
        >
          <div class="flex col-center p-v-8">
            <div class="item-body">
              <span class="item-body__label">一览表序号：</span>
              <span class="item-body__content">
                {{ getContent({ value: item.orderNum }) }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">开标项填写：</span>
              <el-popover
                v-if="getContent({ value: item.markName }).length > 26"
                placement="top"
                trigger="hover"
                width="300"
                :content="getContent({ value: item.markName })"
              >
                <span slot="reference" class="item-body__content">
                  {{
                    getContentAfterSubstr(getContent({ value: item.markName }))
                  }}
                </span>
              </el-popover>
              <span v-else class="item-body__content">
                {{ getContent({ value: item.markName }) }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">填写类型：</span>
              <span class="item-body__content">
                {{
                  getContent({
                    value: item.inputType,
                    dict: bidMarkInputTypeDict
                  })
                }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">单位类型：</span>
              <span
                v-if="item.markType === bidMarkTypeDict.BID_TOTAL.value"
                class="item-body__content"
              >
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="投标报价的单位类型由项目所选的报价方式决定"
                  placement="top"
                >
                  <i class="el-icon-info"></i>
                </el-tooltip>
              </span>
              <span v-else class="item-body__content">
                {{
                  getContent({
                    value: item.markUnit,
                    dict: bidMarkUnitTypeDict
                  })
                }}
              </span>
            </div>
            <el-divider direction="vertical" />
            <div class="item-body">
              <span class="item-body__label">是否必填：</span>
              <span class="item-body__content">
                {{
                  getContent({
                    value: item.markRequire,
                    dict: whetherBooleanDict
                  })
                }}
              </span>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!----招标文件---->
    <div v-if="isRelease" class="section">
      <h6>招标文件</h6>
      <section>
        <upload-authorization-file
          v-if="bidFileId"
          ref="uploadBiddingFile"
          v-model="bidFileId"
          class="upload"
          upload-mode="fileId"
          :preview-api="previewBiddingFileApi"
          :download-api="downloadBiddingFileApi"
          :request-params="{
            isRelease: true,
            orderId: orderId,
            tradeId: tradeId,
            fileId: kpbFileId,
            fileType: fileTypeDict.KPB_BID.value,
            supplementId: supplementId,
            purchaseType: purchaseTypeDict.BIDDING.value
          }"
          :props-data="{
            disabled: true
          }"
        />
        <span v-else>-</span>
      </section>
    </div>
  </div>
</template>
<script>
import UploadAuthorizationFile from '@/components/common/Upload/UploadAuthorizationFile.vue'
import AutomaticScoringDetail from '@/views/procure-views/purchase/invite-bid/components/AutomaticScoringDetail.vue'
import { getKpbBiddingFileApi } from '@/api/procure/kpb-project'
import {
  getKpbFileDetailApi,
  previewBiddingFileApi,
  downloadBiddingFileApi
} from '@/api/procure/invite-bid'

import {
  reviewWayTypeDict,
  bidReviewMethodTypeDict,
  bidReviewPointTypeDict,
  bidMarkInputTypeDict,
  bidMarkUnitTypeDict,
  bidReviewScoringSchemeDict,
  bidMarkTypeDict,
  bidFileDirectoryTypeDict,
  bidReviewScoringTypeDict,
  isScoreOnceDict,
  reviewModelDict,
  reviewMethodModelDict,
  bidFileTypeDict
} from '@/dictionary/project/kpb-project'
import {
  whetherBooleanDict,
  purchaseTypeDict
} from '@/dictionary/project/common'
import { fileTypeDict } from '@/dictionary/project/bid'
import { countRepeatNum } from '@/utils/utils'

export default {
  components: {
    UploadAuthorizationFile,
    AutomaticScoringDetail
  },

  props: {
    kpbFileId: {
      type: [Number, String],
      default: ''
    },

    orderId: {
      type: [Number, String],
      default: ''
    },

    tradeId: {
      type: [Number, String],
      default: ''
    },

    supplementId: {
      type: [Number, String],
      default: ''
    },

    // 是否已发布
    isRelease: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      reviewWayTypeDict,
      bidReviewPointTypeDict,
      bidMarkInputTypeDict,
      bidMarkUnitTypeDict,
      bidReviewScoringSchemeDict,
      whetherBooleanDict,
      fileTypeDict,
      purchaseTypeDict,
      bidMarkTypeDict,
      bidReviewScoringTypeDict,
      isScoreOnceDict,

      previewBiddingFileApi,
      downloadBiddingFileApi,

      // 电子标书信息
      fileInfo: {},

      // 投标文件目录列表
      catalogList: [],
      // 报价文件目录列表
      quotationCatalogList: [],

      // 评审办法列表
      reviewList: [],
      // 报价开标一览表
      quotationMarkList: [],

      // 开标一览表
      markList: [],

      bidFileId: ''
    }
  },

  computed: {
    addressStr() {
      if (this.fileInfo.openBidCountry === '中国') {
        return `${this.fileInfo.openBidProvince}-${this.fileInfo.openBidCity}-${this.fileInfo.openBidArea}`
      } else {
        return this.fileInfo.openBidCountry
      }
    },

    // 显示同时打分设置
    showScoreOnce() {
      // 当有两个及以上的打分型评审时显示，且不是双信封时显示
      const methodNumObj = countRepeatNum(this.reviewList, 'reviewMethod')
      const scoreNum = methodNumObj[bidReviewMethodTypeDict.SCORE.value]?.num
      return scoreNum > 1 && !this.isDouble
    },

    reviewModelLabel() {
      return reviewModelDict.translate(this.fileInfo.reviewModel)?.label
    },

    reviewMethodLabel() {
      return reviewMethodModelDict.translate(this.fileInfo.reviewMethod)?.label
    },

    // 是否是双信封
    isDouble() {
      return this.fileInfo.reviewModel === reviewModelDict.DOUBLE.value
    },

    // 是否是最高价/最低价
    isRankByPrice() {
      const { PRICE_HIGHEST, PRICE_LOWEST } = reviewMethodModelDict
      const rankByPriceList = [PRICE_HIGHEST, PRICE_LOWEST].map(
        item => item.value
      )
      return rankByPriceList.includes(this.fileInfo.reviewMethod)
    },

    showItemOffer() {
      // 双信封报价不允许设置分项报价
      return !this.isDouble
    }
  },

  watch: {
    kpbFileId: {
      handler: function(val) {
        if (!val) return
        if (this.isRelease) {
          this.getKpbFileDetail()
        } else {
          this.getKpbBiddingFile()
        }
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 查询电子标书详情
     */
    getKpbBiddingFile() {
      getKpbBiddingFileApi(this.kpbFileId)
        .then(res => {
          const data = res.data || {}
          this.handleFileInfo(data)
        })
        .catch(err => {
          console.log('查询电子标书详情 err', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    /**
     * 查询电子标书详情
     */
    getKpbFileDetail() {
      let obj = {}
      if (this.supplementId) {
        obj = { supplementId: this.supplementId }
      }
      getKpbFileDetailApi(this.orderId, this.kpbFileId, obj)
        .then(res => {
          const data = res.data || {}
          this.handleFileInfo(data)
        })
        .catch(err => {
          console.log('查询电子标书详情 err', err)
          if (err?.message) this.$message.error(err.message)
        })
    },

    handleFileInfo(data) {
      // 设置电子标书信息
      this.fileInfo = data?.file || {}
      // 设置标书目录信息
      if (data.catalogList?.length) {
        // 商务文件目录
        this.catalogList = data.catalogList.filter(item => {
          // 不显示分项报价目录和开标一览表目录
          const hideList = [
            bidFileDirectoryTypeDict.MARK.value,
            bidFileDirectoryTypeDict.ITEMIZED.value
          ]
          return (
            !hideList.includes(item.catalogType) &&
            item.bidFileType === bidFileTypeDict.BUSINESS.value
          )
        })
        // 报价文件目录
        this.quotationCatalogList = data.catalogList.filter(item => {
          // 不显示分项报价目录和开标一览表目录
          const hideList = [bidFileDirectoryTypeDict.MARK.value]
          return (
            !hideList.includes(item.catalogType) &&
            item.bidFileType === bidFileTypeDict.QUOTATION.value
          )
        })
      }
      // 设置评审办法列表
      this.reviewList = data?.wayList || []
      // 设置开标一览表
      if (data.markList?.length) {
        // 商务开标一览表
        this.markList = data.markList.filter(
          item => item.bidFileType === bidFileTypeDict.BUSINESS.value
        )
        // 报价开标一览表
        this.quotationMarkList = data.markList.filter(
          item => item.bidFileType === bidFileTypeDict.QUOTATION.value
        )
      }
      // 设置标书文件
      const bidFileId = data.file?.biddingAttachmentIds
      this.bidFileId = bidFileId && bidFileId.length ? bidFileId.join(',') : ''
    },

    /**
     * 通过 目录编号获取投标目录名称
     * @param orderNum
     */
    getCatalogNameByOrderNum(orderNum) {
      const temp =
        this.catalogList.find(catalog => catalog.orderNum === orderNum) || {}
      return temp.catalogName || '无关联'
    },

    getContent({ value, dict, fixed2 }) {
      if (dict) {
        return dict.translate(value).label || '-'
      } else if (!isNaN(value) && fixed2) {
        return parseFloat(value).toFixed(2) || '0.00'
      } else {
        return value || '-'
      }
    },

    getContentAfterSubstr(content, max = 26) {
      if (content.length > max) {
        return content.substr(0, max) + '...'
      }
      return content
    },

    isScore(reviewWay) {
      return reviewWay.reviewMethod === bidReviewMethodTypeDict.SCORE.value
    },

    getReviewPointLabel(review) {
      return this.isScore(review) ? '评分' : '评审'
    },

    showCatalog(item) {
      const { MARK, ITEMIZED } = bidFileDirectoryTypeDict
      return (
        item.catalogType !== MARK.value && item.catalogType !== ITEMIZED.value
      )
    },

    // 是否是价格分评审
    isQuotationReview(reviewWay) {
      return (
        reviewWay.wayType ===
        reviewWayTypeDict(this.fileInfo.reviewModel).QUOTATION.value
      )
    }
  }
}
</script>
<style lang="scss" scoped>
$review-border-color: #d9d9d9;
h5 {
  font-size: 24px;
  text-align: center;
  margin-block-start: 0em;
  margin-block-end: 0em;
  padding-bottom: 14px;
}
h6 {
  font-size: 16px;
  margin-block-start: 0em;
  margin-block-end: 0em;
  padding-bottom: 14px;
}
.base-info {
  font-size: 12px;
  margin-top: -8px;
  .item-body {
    display: flex;
    flex-wrap: wrap;
    margin-top: 8px;
    .item-body__label {
      color: $third-text-color;
    }
    .item-body__content {
      color: $text-color;
      word-break: break-all;
      text-align: justify;
    }
  }
}

.review-methods {
  .item-body {
    display: flex;
    flex-wrap: wrap;
    .item-body__label {
      color: $third-text-color;
    }
    .item-body__content {
      color: $text-color;
      word-break: break-all;
      text-align: justify;
    }
  }
}

.list {
  font-size: 12px;
  ::v-deep .el-divider--vertical {
    margin: 0 16px;
  }

  .item-body {
    flex-shrink: 0;
    display: flex;
    flex-wrap: wrap;
    &.one-line {
      width: 100%;
      flex-grow: 1;
    }

    .item-body__label {
      color: $third-text-color;
    }
    .item-body__content {
      color: $text-color;
      word-break: break-all;
    }
  }
}

.review-card {
  width: 100%;
  border: 1px solid $review-border-color;
  overflow: hidden;
  font-size: 12px;
  border-radius: 2px;
  & + .review-card {
    margin-top: 10px;
  }

  .review-card-head {
    width: 100%;
    @include text-bold;
    background: $grey-background-color;
    font-size: 14px;
    padding: 6px 0 10px 13px;
  }

  .item-body__one_line {
    .item-body__label {
      color: $third-text-color;
    }
    .item-body__content {
      color: $text-color;
      text-align: justify;
      word-break: break-all;
    }
  }

  ::v-deep .el-scrollbar {
    .review-card-body {
      height: 244px;
    }
  }
}

.score-setting {
  font-size: 12px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 10px 0 24px;
  border-bottom: 1px solid $border-color;
  margin-bottom: 24px;
}
</style>
